import store from '@/store/store';
import { Market } from '@/bundles/Markets/models/Market';
import { convertMarketToFilterConfig } from '@/bundles/GroupFilters/helpers/markets/convertMarketToFilterConfig';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { StoreModulesNamesEnum } from '@/store/StoreModulesNamesEnum';
import { FilterCategoryEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';

interface IGetMarketsFiltersParams {
  propertyTypes?: string[];
  sourceName?: string;
  category?: FilterCategoryEnum;
  titlePrefix?: string;
}

export const getMarketsFilters = ({ propertyTypes, sourceName, category, titlePrefix }: IGetMarketsFiltersParams = {}): IFilterConfigItem[] => {
  // should be here, as this function called in getDefaultFilterObjectShape where store is init process
  if (!store) { return []; }

  return store.state[StoreModulesNamesEnum.FiltersData].markets.map((market: Market) =>
    convertMarketToFilterConfig(market, { propertyTypes }, { sourceName, category, titlePrefix }),
  );
}
